export default __webpack_public_path__ + "static/media/img_step_7.f9917cd7.svg";